function CopyLink() {
	this._init();
}

CopyLink.prototype = {
	_init: function() {
		this.$copyLink = $('.share-copy-js');
		this.$copyLink.attr('data-clipboard-text', window.location.href);
		this.$copyLink.on('click', e => {
			e.preventDefault();
		});

		// eslint-disable-next-line
		if (!ClipboardJS.isSupported()) {
			this.$copyLink.hide();
		} else {
			this.$clipboard = new ClipboardJS('.share-copy-js'); // eslint-disable-line

			this.$clipboard.on('success', e => {
				this._copyLink();
				e.clearSelection();
			});
			this.$clipboard.on('error', e => {
				console.error('Action:', e.action);
				console.error('Trigger:', e.trigger);
			});
		}
	},
	_copyLink: function() {
		this.$copyLink.addClass('_copied');
		setTimeout(() => {
			this.$copyLink.removeClass('_copied');
		}, 3000);
	},
};

module.exports = new CopyLink();
